import axios from "axios";
import {
  NID_DETAILS_LOADING,
  NID_DETAILS_SUCCESS,
  NID_DETAILS_FAILED,
  UPLOAD_FILE_MULTIPART_LOADING_NID,
  UPLOAD_FILE_MULTIPART_SUCCESS_NID,
  UPLOAD_FILE_MULTIPART_FAILED_NID,
  SAVE_NID_DETAILS_LOADING,
  SAVE_NID_DETAILS_SUCCESS,
  SAVE_NID_DETAILS_FAILED,
  DELETE_FILE_LOADING_NID,
  DELETE_FILE_SUCCESS_NID,
  DELETE_FILE_FAILED_NID,
  NID_DETAILS_WITHOCR_LOADING,
  NID_DETAILS_WITHOCR_SUCCESS,
  NID_DETAILS_WITHOCR_FAILED,
  VERIFY_PROFILE_DATA_LOADING,
  VERIFY_PROFILE_DATA_SUCCESS,
  VERIFY_PROFILE_DATA_FAILED,
  CAPTCHA_DATA_LOADING,
  CAPTCHA_DATA_SUCCESS,
  CAPTCHA_DATA_FAILED,
  SEND_OTP_LOADING,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAILED,
  VERIFY_OTP_LOADING,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILED,
  SAVE_PAN_LOADING,
  SAVE_PAN_SUCCESS,
  SAVE_PAN_FAILED,
  NID_OCR_FLAG_LOADING,
  NID_OCR_FLAG_SUCCESS,
  NID_OCR_FLAG_FAILED
} from "../Constants/nidConstants";
import { toast } from "react-toastify";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { handleApiError } from "../Helper/actionHelper";


const errorMsg = "Something went wrong. Please try again.";

export const getNIDDetails = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: NID_DETAILS_LOADING });
    const requestData = {
      token: userLocalData.id,
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/getNid",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: NID_DETAILS_SUCCESS,
      payload: data,
    });

    handleApiError(data);

  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: NID_DETAILS_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const getNIDDetailsWithOCR = (record={}) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: NID_DETAILS_LOADING });
    // dispatch({ type: NID_DETAILS_WITHOCR_LOADING });
    const requestData = {
      token: userLocalData.id,
      ...record
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/InstantNid/getNidDetails",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: NID_DETAILS_SUCCESS,
      payload: data,
    });

    // dispatch({
    //   type: NID_DETAILS_WITHOCR_SUCCESS,
    //   payload: data,
    // });

    handleApiError(data);

  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: NID_DETAILS_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    // dispatch({
    //   type: NID_DETAILS_WITHOCR_FAILED,
    //   payload:
    //     error.response && error.response.data.message
    //       ? error.response
    //       : error.response,
    // });
    handleApiError(error);
  }
};

export const uploadFileViaMultipartNID =
  (
    docCheckID,
    docSubCheckID,
    docSide,
    docNID,
    checkIDData,
    file,
    fieldName,
    fieldNIDIndex,
    activeIndex,
    OCRFlag,
    callback=()=>{},
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: UPLOAD_FILE_MULTIPART_LOADING_NID });
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

      let formData = new FormData();
      formData.append("token", userLocalData.id);
      formData.append("doc_chkid", docCheckID);
      formData.append("doc_sub_chkid", docSubCheckID);
      formData.append("doc_nid", docNID);
      formData.append("doc_side", docSide);
      formData.append("check_id_data", checkIDData);
      formData.append("mode", "nid_file");
      formData.append("thisdata[]", file);

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data } = await axios.post(FOLDERPATH + 
        "/CandidateApi/uploadFiles",
        formData,
        {
          headers,
        }
      );
      
      if (data.status == "success") {
        const uploadedFileName =
          docNID === "NID_Default_Field"
            ? `${docNID}-${fieldNIDIndex}-${fieldName}`
            : `${docNID}-${fieldName}`;
        const dataObj = {
          uploadedFileName: uploadedFileName,
          preview: data?.data?.preview_key,
          uploadedDocId: data?.data?.document_id,
        };

        dispatch({
          type: UPLOAD_FILE_MULTIPART_SUCCESS_NID,
          payload: dataObj,
        });

        if(!OCRFlag){
          callback(data?.data, docSide,fieldName, checkIDData, file?.name);
        }
        // const payload={case_chcek_id:checkIDData,'front_image':data.data.preview_key}
        // dispatch(excuteOCR(payload,setLoading));
        const msg = "File uploaded successfully";
        toast.success(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        
        if(OCRFlag){
        dispatch({
          type: VERIFY_PROFILE_DATA_SUCCESS,
          payload: {[docSubCheckID]:{isverified:false,value:{}}}
      })
      dispatch({
        type: SEND_OTP_SUCCESS,
        payload: {isSentOtp:false}
    })
        let obj={};
        if(activeIndex == 1){
          obj.is_aadhar_linked=0;
        }
        dispatch(getNIDDetailsWithOCR(obj));
      }

      }else{
        dispatch({
          type: UPLOAD_FILE_MULTIPART_SUCCESS_NID,
          payload: {},
        });
        const msg = data?.message;

        toast.error(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

      }

      handleApiError(data);
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: UPLOAD_FILE_MULTIPART_FAILED_NID,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
      handleApiError(error);
    }
  };

export const saveNIDDetails =
  (payload, nid_selected, ele_doc_name, ele_doc_numb, ele_check_id) =>
  async (dispatch) => {
    try {
      dispatch({ type: SAVE_NID_DETAILS_LOADING });

      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

      let requestData = {
        token: userLocalData.id,
      };

      requestData["nid_selected"] = payload.nid_selected;
      requestData["ele_doc_name"] = payload.ele_doc_name;
      requestData["ele_doc_numb"] = payload.ele_doc_numb;
      requestData["ele_check_id"] = payload.ele_check_id;
      if(payload.nid_selected == "371"){
        requestData["check_data"] = payload.check_data;
      }

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data } = await axios.post(FOLDERPATH + 
        "/CandidateApi/saveNid",
        requestData,
        {
          headers,
        }
      );
      if (data.status == "success") {
        dispatch({
          type: SAVE_NID_DETAILS_SUCCESS,
          payload: data,
        });
        const msg = "Saved Successfully";

        toast.success(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      handleApiError(data);
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: SAVE_NID_DETAILS_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
      handleApiError(error);
    }
  };

export const removeUploadedFile =
  (mode, record = null, docSide, callback=()=>{},activeIndex,ocrflag,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: DELETE_FILE_LOADING_NID });

      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

      const requestData = {
        token: userLocalData.id,
        mode: mode,
        ...record,
      };

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data } = await axios.post(FOLDERPATH + 
        "/CandidateApi/removeFiles",
        requestData,
        {
          headers,
        }
      );

      dispatch({
        type: DELETE_FILE_SUCCESS_NID,
        payload: data,
      });

      if(ocrflag){
        dispatch({
          type: VERIFY_PROFILE_DATA_SUCCESS,
          payload: {[id]:{isverified:false,value:{}}}
      })
      dispatch({
        type: SEND_OTP_SUCCESS,
        payload: {isSentOtp:false}
    })
        let obj={};
        if(activeIndex == 1){
          obj.is_aadhar_linked=0;
        }
        dispatch(getNIDDetailsWithOCR(obj));
      }
      callback(data?.data, record, mode, docSide);

      const msg = "Removed Successfully";
      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      handleApiError(data);
    } catch (error) {
      const msg = "Removed Successfully";
      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: DELETE_FILE_FAILED_NID,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
      let obj={};
      if(activeIndex == 1){
        obj.is_aadhar_linked=0;
      }
      dispatch(getNIDDetailsWithOCR(obj));
      handleApiError(error);
    }
  };

export const deleteSaveNIDDetails = () => async (dispatch) => {
  dispatch({
    type: SAVE_NID_DETAILS_SUCCESS,
    payload: [],
  });
};

export const deleteSavePanDetails = () => async (dispatch) => {
  dispatch({
    type: SAVE_PAN_SUCCESS,
    payload: [],
  });
};

export const excuteOCR = (payload,callback) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    // dispatch({ type: NID_DETAILS_LOADING });
    // dispatch({ type: NID_DETAILS_WITHOCR_LOADING });
    const requestData = {
      token: userLocalData.id,
      ...payload
    };
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };
    callback(true);
    const { data } = await axios.post(FOLDERPATH + 
      "/InstantNid/docClassification",
      requestData,
      {
        headers: headers,
      }
    );
    callback(false);
    if (data.status == "success") {
    dispatch(getNIDDetailsWithOCR())
    }else{
      const errorMsg=data.message;
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    handleApiError(data);

  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
   callback(false);
    handleApiError(error);
  }
};

export const verifyProfileChecks = (payload, callback,nidCheckId) => async (dispatch) => {
  try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: VERIFY_PROFILE_DATA_LOADING });
      const toastId = toast.loading("Verification in process...");
      const requestData = {
          token: userLocalData.id,
          ...payload,
      };

      const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
      };

      const { data } = await axios.post(FOLDERPATH +
          "/PreVerificationApi/verifyChecks",
          requestData,
          {
              headers: headers,
          }
      );
      console.log('PREVICATION_DATA....', data)
      const isverified=data.status=='success'?true:false
      dispatch({
          type: VERIFY_PROFILE_DATA_SUCCESS,
          payload: {[nidCheckId]:{isverified,value:data?.data}}
      })

      const msg = data?.message || data?.msg;

      if (data?.status == "success" || data?.success) {
        callback({[nidCheckId]:{isverified,value:data?.data}});
          toast.update(toastId, {
              render: msg || "Verified",
              type: "success",
              autoClose: 3000,
              isLoading: false,
          });
      } else {
          toast.update(toastId, {
              render: msg || "Something went wrong",
              type: "error",
              autoClose: 3000,
              isLoading: false,
          });
      }

      handleApiError(data); //in case API return 200 with error details
  } catch (error) {
      toast.error(errorMsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
      });
      dispatch({
          type: VERIFY_PROFILE_DATA_FAILED,
          payload:
              error.response && error.response.data.message
                  ? error.response
                  : error.response,
      });
      console.log('PREVICATION_DATA..', error)

      handleApiError(error);
  }
};

export const verifyOtp = (payload, callback,nidCheckId) => async (dispatch) => {
  try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      // dispatch({ type: VERIFY_OTP_LOADING });
      dispatch({ type: VERIFY_PROFILE_DATA_LOADING });
      const requestData = {
          token: userLocalData.id,
          ...payload
      };

      const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
      };

      const { data } = await axios.post(FOLDERPATH +
          "/CandidateApi/verifyMobileOtpAadharDetails",
          requestData,
          {
              headers: headers,
          }
      );
      console.log('PREVICATION_DATA....', data)

      // dispatch({
      //     type: VERIFY_OTP_SUCCESS,
      //     payload: data
      // })
      const isverified=data.status=='success'?true:false
      dispatch({
        type: VERIFY_PROFILE_DATA_SUCCESS,
        payload: {[nidCheckId]:{isverified,value:data?.data}}
    })
      callback();

      const msg = data?.message || data?.data?.msg;
      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
      handleApiError(data); //in case API return 200 with error details
  } catch (error) {
      toast.error(errorMsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
      });
      dispatch({
        type: VERIFY_PROFILE_DATA_FAILED,
        payload:
            error.response && error.response.data.message
                ? error.response
                : error.response,
    });
      // dispatch({
      //     type: VERIFY_OTP_FAILED,
      //     payload:
      //         error.response && error.response.data.message
      //             ? error.response
      //             : error.response,
      // });
      console.log('PREVICATION_DATA..', error)

      handleApiError(error);
  }
};

export const generateCaptcha = () => async (dispatch) => {
  try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: CAPTCHA_DATA_LOADING });
      const requestData = {
          token: userLocalData.id,
      };

      const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
      };

      const { data } = await axios.post(FOLDERPATH +
          "/CandidateApi/getAadharCaptchaCodeApi",
          requestData,
          {
              headers: headers,
          }
      );
      console.log('PREVICATION_DATA....', data)

      dispatch({
          type: CAPTCHA_DATA_SUCCESS,
          payload: data
      })

      const msg = data?.message || data?.msg;
      handleApiError(data); //in case API return 200 with error details
  } catch (error) {
      // toast.error(errorMsg, {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      // });
      dispatch({
          type: CAPTCHA_DATA_FAILED,
          payload:
              error.response && error.response.data.message
                  ? error.response
                  : error.response,
      });
      console.log('PREVICATION_DATA..', error)

      handleApiError(error);
  }
};

export const sendOtp = (payload, callbackAadharVerify,isResend=false) => async (dispatch) => {
  try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      if(!isResend){
      dispatch({ type: SEND_OTP_LOADING });
      }
      const requestData = {
          token: userLocalData.id,
          ...payload
      };

      const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
      };

      const { data } = await axios.post(FOLDERPATH +
          "/CandidateApi/sendMobileOtpAadharDetails",
          requestData,
          {
              headers: headers,
          }
      );
      console.log('PREVICATION_DATA....', data)
      
      if(!isResend){
       const isSentOtp=data.status=='success'?true:false;
        
      dispatch({
          type: SEND_OTP_SUCCESS,
          payload: {isSentOtp,...data.data}
      })
    }

      callbackAadharVerify();

      const msg = data?.message || data?.data?.msg;
      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
      handleApiError(data); //in case API return 200 with error details
  } catch (error) {
      // toast.error(errorMsg, {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      // });
      if(!isResend){
      dispatch({
          type: SEND_OTP_FAILED,
          payload:
              error.response && error.response.data.message
                  ? error.response
                  : error.response,
      });
    }
      console.log('PREVICATION_DATA..', error)

      handleApiError(error);
  }
};

export const savePan = (payload = {},activeIndex="", callback=()=>{}) => async (dispatch) => {
  try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      // payload.token=userLocalData.id;
      // let formData = new FormData();

      let newPayload = convertToFormData(payload);

      Object.keys(payload).map((k) => {
        if(k == "rotate_image_front" || k == "rotate_image_back") {
          newPayload.append(`${k}`, payload[k]);
        } 
        // else {
        //   formData.append(`${k}[0]`, payload[k]);
        // }
      });
      newPayload.append("token", userLocalData.id);

      // console.log("Formdata....", formData)
      // const formData = new FormData(formElement);

      newPayload.forEach((value, key) => {
        console.log(`${key}: ${value}`);
      });
      dispatch({ type: SAVE_PAN_LOADING });
      const requestData = {
          token: userLocalData.id,
          ...payload
      };

      const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
      };

      const { data } = await axios.post(FOLDERPATH +
          "/InstantNid/saveNidDetails",
          newPayload,
          {
              headers: headers,
          }
      );
      console.log('PREVICATION_DATA....', data)

      dispatch({
          type: SAVE_PAN_SUCCESS,
          payload: data
      })
      callback(data?.data);

      let obj={};
      if(activeIndex == 1){
        obj.is_aadhar_linked=0;
      }

      localStorage.setItem("NIDSaved", true);
      dispatch(getNIDDetailsWithOCR(obj));

      const msg = data?.message || data?.msg;
      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
      handleApiError(data); //in case API return 200 with error details
  } catch (error) {
      toast.error(errorMsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
      });
      dispatch({
          type: SAVE_PAN_FAILED,
          payload:
              error.response && error.response.data.message
                  ? error.response
                  : error.response,
      });
      console.log('PREVICATION_DATA..', error)

      handleApiError(error);
  }
};

function convertToFormData(obj, formData = new FormData(), parentKey = '') {
  if (obj === null || obj === undefined) return formData;

  if (typeof obj === 'object' && !(obj instanceof File)) {
    if (Array.isArray(obj)) {
      obj.forEach((item, index) => {
        convertToFormData(item, formData, `${parentKey}[${index}]`);
      });
    } else {
      Object.entries(obj).forEach(([key, value]) => {
        const fullKey = parentKey ? `${parentKey}[${key}]` : key;
        convertToFormData(value, formData, fullKey);
      });
    }
  } else {
    // Handle primitive values and File objects
    formData.append(parentKey, obj);
  }

  return formData;
}

export const getNidOCRFlag = (callback) => async (dispatch) => {
  try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: NID_OCR_FLAG_LOADING });
      const requestData = {
          token: userLocalData.id,
      };

      const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
      };
      // https://ibridge-uat.authbridge.com/idemo/InstantNid/checkConfigExists
      const { data } = await axios.post(FOLDERPATH +
          "/InstantNid/checkConfigExists",
          requestData,
          {
              headers: headers,
          }
      );
      console.log('OCR flag....', data)

      dispatch({
          type: NID_OCR_FLAG_SUCCESS,
          payload: data
      })
      callback(data);

      const msg = data?.message || data?.msg;
    //   toast.error(msg, {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    // });
      handleApiError(data); //in case API return 200 with error details
  } catch (error) {
      // toast.error(errorMsg, {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      // });
      dispatch({
          type: NID_OCR_FLAG_FAILED,
          payload:
              error.response && error.response.data.message
                  ? error.response
                  : error.response,
      });
      console.log('PREVICATION_DATA..', error)

      handleApiError(error);
  }
};


export const nextTabApi = (payload,callback=()=>{},setIsLoading) => async (dispatch) => {
  try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      const requestData = {
          token: userLocalData.id,
           ...payload
      };

      const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
      };
       setIsLoading(true);
      const { data } = await axios.post(FOLDERPATH +
          "/InstantNid/navigateNid",
          requestData,
          {
              headers: headers,
          }
      );
      setIsLoading(false);
      callback(data?.data);
      handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    setIsLoading(false);
      toast.error(errorMsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
      });
      handleApiError(error);
  }
};

export const getAadharDigiUrl = (payload, callbackAadharVerify, nidCheckId, isResend=false) => async (dispatch) => {
  try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      if(!isResend){
      dispatch({ type: SEND_OTP_LOADING });
      }
      const requestData = {
          token: userLocalData.id,
          ...payload
      };

      const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
      };

      const { data } = await axios.post(FOLDERPATH +
          "/CandidateApi/sendMobileOtpAadharDetails",
          requestData,
          {
              headers: headers,
          }
      );
      console.log('PREVICATION_DATA....', data)
      
      if(!isResend){
       const isSentOtp=data.status=='success'?true:false;
        
      dispatch({
          type: SEND_OTP_SUCCESS,
          payload: {isSentOtp,...data.data}
      })
      const isverified=data.status=='success'?true:false
      dispatch({
        type: VERIFY_PROFILE_DATA_SUCCESS,
        payload: {[nidCheckId]:{isverified,value:data?.data}}
    })
    }

      callbackAadharVerify(data?.data);

    //   const msg = data?.message || data?.data?.msg;
    //   toast.success(msg, {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    // });
      handleApiError(data); //in case API return 200 with error details
  } catch (error) {
      // toast.error(errorMsg, {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      // });
      if(!isResend){
      dispatch({
          type: SEND_OTP_FAILED,
          payload:
              error.response && error.response.data.message
                  ? error.response
                  : error.response,
      });
    }
      console.log('PREVICATION_DATA..', error)

      handleApiError(error);
  }
};

